// extracted by mini-css-extract-plugin
export var active = "Carousel-module--active--6c7aa";
export var image = "Carousel-module--image--9b7aa";
export var next = "Carousel-module--next--320d0";
export var previous = "Carousel-module--previous--b1934";
export var root = "Carousel-module--root--40890";
export var slide = "Carousel-module--slide--48666";
export var slides = "Carousel-module--slides--c5ee7";
export var slidesWrapper = "Carousel-module--slides-wrapper--eb7d4";
export var subText = "Carousel-module--sub-text--8fc7b";